import { css } from 'styled-components';
import { BaseButtonProps } from 'types';
import { buttonBackgroundAndColorDecorator } from 'utils';
import { base } from './base';

export const regular = ({ background, ...rest }: BaseButtonProps) => css`
	${base(rest)}
	${buttonBackgroundAndColorDecorator(background)}
`;
